/* global bitmovin */
/**
 * Dependencies
 */

import AbstractHTML5Player from '../AbstractHTML5Player';
import { PONCONNECT, PONSTOP } from '../settings';
import { Player, PlayerEvent } from 'bitmovin-player/modules/bitmovinplayer-core';

import {
    configSourceStreamTypes,
    getBitmovinConfig,
    addModules,
    closeSkipButtonAds,
    showSkipButtonAds,
} from './utils';
import Utils from 'src/utils/Utils';
import { AdsUtils } from 'src/AAF/Ads/Utils.js';
import Constants from 'src/AAF/Ads/Constans.js';
import store from "../../../store";
import {
  playNextContent
} from "../../../components/Modal/functions/ModalEndPlayer/functions";
import { setDataNextEpisodeAds } from "../../../actions/ads";
import { playFullMedia } from 'src/actions/playmedia';
import LayersControl from 'src/utils/LayersControl';
import ExperienceHourRefresh from 'src/AAF/Ads/AdsTimer';

let BitmovinPlayer;

/* TODO should this inherit from HTML5? */
class AAFBitmovinPlayer extends AbstractHTML5Player {
    constructor() {
        super();
        console.log('[BITMOVIN PLAYER] AVPlayer constructor init..');
        // Create bitmovin objects if not
        console.log('[BITMOVIN PLAYER] AVPlayer constructor init 2');
        this.prependPip = '';
        this.firstBufferingComplete = false;

        console.log('[BITMOVIN PLAYER] AVPlayer constructor');

        this.retryIntervalFirstPlaying = 0.7;
        this.retryLimitFirstPlaying = 20;

        this.seekWindow = null;
        this.getBitmovinState = this.getBitmovinState.bind(this);
        this.playerStarts = false;
        this.setTimeOutSkepButton = null;
        this.resumeEndAds = 0;
        this.cancelPostRoll = false;
        this.includeAds = false;
        this.willContinuePlaying = true;

        addModules(Player);
        // const di_v = document.getElementById('ctime');
        // di_v.innerHTML = window.location.protocol + '\n <br/>';

        this.retryLimitAudioTrack = 50;

        this._isOnLoaded = false;

        this.hide = this.hide.bind(this);
        this.show = this.show.bind(this);
        this.addEventsListeners = this.addEventsListeners.bind(this);
        this.removeEventsListener = this.removeEventsListener.bind(this);
        this.tryGetAudioTracks = this.tryGetAudioTracks.bind(this);
        this.getAudioTracks = this.getAudioTracks.bind(this);

        this.setAudioTrack = this.setAudioTrack.bind(this);
        this.trySetAudioTrack = this.trySetAudioTrack.bind(this);
        this.getAudioIndexOfCode = this.getAudioIndexOfCode.bind(this);
        this.getCurrentTime = this.getCurrentTime.bind(this);

        // Bind please, just in case...
        this._onCanPlay = this._onCanPlay.bind(this);
        this.setDuration = this.setDuration.bind(this);
        this._onPlaying = this._onPlaying.bind(this);
        this._onLoad = this._onLoad.bind(this);
        this._onTimeUpdate = this._onTimeUpdate.bind(this);
        this.stop = this.stop.bind(this);
        this._onFinished = this._onFinished.bind(this);
        this._onError = this._onError.bind(this);
        this.show = this.show.bind(this);
        this._onDurationChange = this._onDurationChange.bind(this);
        this.hasAudioTracks = false;
    }

    createMedia(options) {
        console.log('[BITMOVIN] Player createMedia', options);
        console.log(options);

        if (options.isPip) return;

        if (this._isPrepared) return;
        const { playerMedia: { next_group:{common = {}} = {} } = {} } = options || {};

        this.options = options;
        store.dispatch(setDataNextEpisodeAds(common));
        this.resumeEndAds = this.options.resume

        this.prependPip = options.isPip ? '_pip' : '_full';
        this._playerContainer = document.createElement('div');
        this._playerContainer.style.position = 'absolute';

        this._playerContainer.id = `Html5PlayerContainer${this.prependPip}`;
        this._playerContainer.className = 'Html5PlayerContainer';

        // Call to the parent, set background
        this.setPlayerBackground(options.backgroundImage ? options.backgroundImage : null);

        if (!this.streamIsAudio()) {
            this._playerContainer.className += ' bitmovinFullContainer';
        }

        this._playerHTMLTag = window.document.createElement('div');
        this._playerHTMLTag.setAttribute('id', 'Html5Player' + this.prependPip);
        this._playerHTMLTag.className = 'Html5PlayerBit';
        this._playerContainer.appendChild(this._playerHTMLTag);

        const vWrapper = document.getElementById(this.options.parentWrapper.id);
        vWrapper.classList.remove('background-clear');
        vWrapper.className += ' background-clear';
        vWrapper.appendChild(this._playerContainer);

        if (!this.options.parentWrapper) {
            throw new Error('Bitmovin player parentWrapper not found...');
        }

        // Opposite to orsay
        this._isPrepared = true;
    }

    loadMedia() {
        console.log(
            '[BITMOVIN] <<<<<<<<<<< INIT bitmovinPlayer loadMedia with options: ',
            this.options
        );
        // At this moment, there is no pip player in orsay (maybe pip with html5 video tag is possible
        if (this.options.isPip) {
            return;
        }

        if (!this._isPrepared) {
            return false;
        }

        if (this.resumeEndAds && !this.options.isLive) {
            this.seek_resume = this.resumeEndAds;
        }

        if (this.options.src) {
            this._isOnLoaded = false;

            const configPlayer = getBitmovinConfig(this.options, false);
            const listeners = this.addEventsListeners();
            const configPlayerWithListeners = { ...configPlayer, events: listeners };

            BitmovinPlayer = new Player(
                document.getElementById('Html5Player' + this.prependPip),
                configPlayerWithListeners
            );

            const source = configSourceStreamTypes({ ...this.options });

            BitmovinPlayer.load(source)
                .then(function () {
                    console.log('✅ [BITMOVIN]: Successfully loaded Source Config!');
                })
                .catch(function (reason) {
                    console.error('❌ [BITMOVIN]: Error while loading source:', reason);
                });

            this.setPlayerFull();
            this.hide(this.options);
        } else {
            this.destroy();
        }
        console.log('[BITMOVIN] Player end loadMedia');
    }

    setPlayerFull() {
        this.setPlayerSize(0, 0, 1280, 720);
    }

    setPlayerSize(top, left, width, height) {
        if (this.options.parentWrapper) {
            const vWrapper = document.getElementById(this.options.parentWrapper.id);
            if (vWrapper && vWrapper.parentNode) {
                vWrapper.parentNode.style.top = top + 'px';
                vWrapper.parentNode.style.left = left + 'px';
                vWrapper.parentNode.style.width = width + 'px';
                vWrapper.parentNode.style.height = height + 'px';
            }
        }

        this._playerContainer.style.top = '0px';
        this._playerContainer.style.left = '0px';
        this._playerContainer.style.width = `${width}px`;
        this._playerContainer.style.height = `${height}px`;
        this._playerContainer.style.position = 'relative';

        return true;
    }

    async tryOnFirstPlaying(currentTry) {
        if (!this._isOnLoaded) {
            console.log(`[BITMOVIN] retry number: [${currentTry}]`);
            if (currentTry >= this.retryLimitFirstPlaying) {
                throw new Error('Fail to get playing state');
            }
            await Utils.sleep(this.retryIntervalFirstPlaying);

            return this.tryOnFirstPlaying(++currentTry);
        }
        console.log('[BITMOVIN]> player is ready and playing');
        return this.play(false);
    }

    setTimeshift() {}

    /**
     * Notify when enter playing first time (after playing firs time or after replace source)
     */
    onFirstPlaying() {}

    play() {
        BitmovinPlayer.play();
        console.log('[BITMOVIN] ENTER PLAY DO EXECUTE PLAY');
    }

    resume() {
        BitmovinPlayer.play();

        console.log('[BITMOVIN] ENTER PLAY DO EXECUTE RESUME');
    }

    pause() {
        BitmovinPlayer.pause();
    }

    stop() {
        this.removeEventsListener();
        BitmovinPlayer.pause();
        if (this._playerContainer && this._playerContainer.parentNode) {
            this._playerContainer.parentNode.removeChild(this._playerContainer);
        }
    }

    async skipAds() {
        await BitmovinPlayer.ads.skip().then(() => {
            closeSkipButtonAds();
        });
    }

    async tryOnFirstStartOverSeek() {}

    seekStartOver() {}

    /* PLAYER CONTROL */
    seekTimeshift() {}

    async tryOnFirstTimeshiftSeek() {}

    seek(seconds) {
        console.log('[BITMOVIN] 🚀 ~ AAFBitmovinPlayer ~ seek ~ seconds:', seconds);
        this.skip(seconds);
    }

    skip(seconds) {
        BitmovinPlayer.seek(seconds);
    }

    replaceMediaSource(newSource) {
        // no replace for pip
    }

    hide() {
        if (this._playerContainer) {
            console.log(
                '[BITMOVIN] hide wrapper object, to see background in screen while we await for play',
                this._playerContainer,
                this._playerContainer.childNodes
            );
            if (this._playerContainer.childNodes[0])
                this._playerContainer.childNodes[0].style.visibility = 'hidden';
        }
    }

    show() {
        if (this._playerContainer && !this.streamIsAudio()) {
            console.log(
                '[BITMOVIN] show bitmovin object, will not see background in screen we are playing'
            );
            this._playerContainer.childNodes[0].style.visibility = 'visible';
        }
    }

    destroy() {
        if (this.options.isPip) {
            return;
        }

        if (!this._isPrepared) {
            return;
        }

        /*
// if we are un epg and did a replace, we dont need to destroy player
// we come from a replace
if(this.options.newSource && this.options.newSource.src) {
  this.currentContentTime = 0;
  return;
}
*/      
        this.hasAudioTracks = false;
        this.contentIsReady = false;
        this.firstBufferingComplete = false;
        this._isOnLoaded = false;
        this.seek_resume = 0;
        this.stop();
        // .off() to remove listeners
        this.removeEventsListener();

        BitmovinPlayer.destroy().then(() => {
            this.playerStarts = false;

            if (this._playerContainer) {
                if (!this.streamIsAudio()) {
                    if (this._playerContainer) {
                        this._playerContainer.className = this._playerContainer.className.replace(
                            'bitmovinFullContainer',
                            ' '
                        );
                    }
                }

                this._playerContainer.innerHTML = '';

                if (this._playerContainer && this._playerContainer.parentNode) {
                    this._playerContainer.parentNode.removeChild(this._playerContainer);
                }

                this._playerContainer = null;
                this.avplayerObject = null;
            }

            this._isPrepared = false;

            this.audioTracks = [];
            this.currentAudioTrackIndex = null;
            this.seekWindow = null;

            // Call to the parent...
            this.setPlayerBackground(null);

            this.previousPlayerState = PONCONNECT;
            this.currentPlayerState = PONCONNECT;

            ExperienceHourRefresh.whenPlayerStopBitmovin();

            Promise.resolve(true);
        });
    }

    eventsToPlayerReady() {
        this._onCanPlay();
        this.playerStarts = true;
        this._isOnLoaded = true;
        this.show();
        this._onLoad();
        this._onPlaying();
        let duration = BitmovinPlayer.getDuration();
        if (isNaN(duration)) duration = 0;
        duration = Math.floor(duration);
        this.setDuration(duration);
        this._onDurationChange();
    }

    isSerie(){
      const { nextData = {} } = store.getState().ads || {};
      const thereAreNextGroup = Object.keys(nextData).length > 0;

      return thereAreNextGroup;
    }

    playbackNextEpisode(adBreakId, isPostRoll) {
        if(ExperienceHourRefresh.getIsPlaying() && isPostRoll ){
            this.dispatchStopping();
            ExperienceHourRefresh.whenPlayerStopBitmovin();
            return;
        }
      const { nextData = {} } = store.getState().ads || {};
      const validatePlayNextContent = adBreakId === Constants.ID_POST_ROLL_BITMOVIN_DATA;

      validatePlayNextContent && playNextContent(nextData);

    }

    dispatchStopping(){
        store.dispatch(playFullMedia({
            ispip: false,
            islive: false,
            ispreview: false,
            payway_token: "",
            source: {
                videoid: null,
            },
            playerstate: 'STOPPING',
          }));
          LayersControl.showUX();
    }

    reviewAdsNowPlaying(adBreakId, beforeAdBreakId) {
      const isPostRoll = adBreakId === Constants.ID_POST_ROLL_BITMOVIN_DATA ||
                beforeAdBreakId === Constants.ID_POST_ROLL_BITMOVIN_DATA;

      const isPreRoll = adBreakId === Constants.ID_PRE_ROLL_BITMOVIN_DATA ||
                beforeAdBreakId === Constants.ID_PRE_ROLL_BITMOVIN_DATA;

      return {isPostRoll, isPreRoll}
    }

    addEventsListeners() {
        let isShowingAds = false;
        let beforeAdBreakId = ""
        let adBreakId = ""
        const events = {
            [PlayerEvent.SourceLoaded]: (e) => {
                console.debug(`🔍 [BITMOVIN - LOG]: Player Event Source loaded `, e);
                this._onCanPlay();
            },
            [PlayerEvent.Play]: (e) => {
                console.debug(`🔍 [BITMOVIN - LOG]: Player Event Play `, e);
                this.setPlayerBackground(null);
            },
            [PlayerEvent.Paused]: (e) => {
                console.debug(`🔍 [BITMOVIN - LOG]: Player Event Paused `, e);
                this.setPlayerBackground(
                    this.options.backgroundImage ? this.options.backgroundImage : null
                );
            },
            [PlayerEvent.StallStarted]: (e) => {
                console.debug(`🔍 [BITMOVIN - LOG]: Player Event StallStarted `, e);
            },
            [PlayerEvent.StallEnded]: (e) => {
                console.debug(`🔍 [BITMOVIN - LOG]: Player Event StallEnded `, e);
            },
            [PlayerEvent.Seek]: (e) => {
                console.debug(`🔍 [BITMOVIN - LOG]: Player Event Seek `, e);
            },
            [PlayerEvent.Seeked]: (e) => {
                console.debug(`🔍 [BITMOVIN - LOG]: Player Event Seeked `, e);
            },

            [PlayerEvent.Error]: (e) => {
                console.error('❌ [BITMOVIN - LOG]: Player Event Error:', e);

                //const { code, message, name } = e;
                // const di_v = document.getElementById('ctime');
                // const txt = di_v.innerHTML;
                // di_v.innerHTML = txt + `${code}, ${name}, ${message}`;

                this.setPlayerBackground(null);
                Utils.resetBackground();
                this._onError(e);
            },
            [PlayerEvent.Ready]: (e) => {
                console.debug(`+++ 🔍 [BITMOVIN - LOG]: Player Event Ready `, e);
                this.eventsToPlayerReady();
                const canResumePlaybackWithoutAds = !this.includeAds && this.seek_resume > 0 && this.willContinuePlaying === true;
                if (canResumePlaybackWithoutAds) {
                    BitmovinPlayer.seek(this.seek_resume);
                    this.willContinuePlaying = false;
                }
            },

            [PlayerEvent.PlaybackFinished]: (e) => {
                this.setPlayerBackground(
                    this.options.backgroundImage ? this.options.backgroundImage : null
                );
                this.stop();
                this._onFinished();
            },

            [PlayerEvent.TimeChanged]: (e) => {
                const { time } = e;
                !isShowingAds && this._onTimeUpdate(time);
            },

            [PlayerEvent.AdStarted]: (data) => {
                this.show();
                isShowingAds = true;
                closeSkipButtonAds();

                const isSkippable = data.ad.skippable;
                const skippableAfter = data.ad.skippableAfter * 1000;
                const skippableAfterDefault = AdsUtils.getSkipOffSet() * 1000;

                const timeShowSkip = isSkippable ? skippableAfter : skippableAfterDefault;

                this.setTimeOutSkepButton =
                    isSkippable && timeShowSkip > 0
                        ? setTimeout(() => {
                              showSkipButtonAds();
                          }, timeShowSkip)
                        : null;
            },

            [PlayerEvent.AdSkipped]: (data) => {
                const adNowPlaying = this.reviewAdsNowPlaying(adBreakId, beforeAdBreakId);
                const { isPostRoll, isPreRoll } = adNowPlaying;

                isShowingAds = false;
                this.playbackNextEpisode(adBreakId, isPostRoll);
                closeSkipButtonAds();

                isPreRoll && this.eventsToPlayerReady();

            },

            [PlayerEvent.AdBreakStarted]: (data) => {
              closeSkipButtonAds();
              const { rolls = {} } = store.getState().ads || {};
              const { ID_POST_ROLL_BITMOVIN_DATA,
                ID_PRE_ROLL_BITMOVIN_SERVICE,
                ID_POST_ROLL_BITMOVIN_SERVICE,
                ID_PRE_ROLL_BITMOVIN_DATA
              } = Constants;

              beforeAdBreakId = data.adBreak.id;
              adBreakId = data.adBreak.id;
              const isActivePreRoll = rolls[ID_PRE_ROLL_BITMOVIN_SERVICE] && rolls[ID_PRE_ROLL_BITMOVIN_SERVICE] === 'true';
              const isActivePostRoll = rolls[ID_POST_ROLL_BITMOVIN_SERVICE] && rolls[ID_POST_ROLL_BITMOVIN_SERVICE] === 'true';
              const notShowPreRollAd = adBreakId === ID_PRE_ROLL_BITMOVIN_DATA && !isActivePreRoll
              const notShowPostRollAd = (adBreakId === ID_POST_ROLL_BITMOVIN_DATA && !isActivePostRoll) || this.cancelPostRoll;

              notShowPreRollAd && BitmovinPlayer.ads.discardAdBreak(adBreakId);
              notShowPostRollAd && BitmovinPlayer.ads.discardAdBreak(adBreakId);

              if (isActivePreRoll || isActivePostRoll) this.includeAds = true;
            },

            [PlayerEvent.AdFinished]: (data) => {
                const adNowPlaying = this.reviewAdsNowPlaying(adBreakId, beforeAdBreakId);
                const { isPostRoll, isPreRoll } = adNowPlaying;
                isShowingAds = false;

                this.playbackNextEpisode(adBreakId, isPostRoll);
                closeSkipButtonAds();
                clearTimeout(this.setTimeOutSkepButton);
                isPreRoll && this.eventsToPlayerReady();
                adBreakId = "";
            },

            [PlayerEvent.AdBreakFinished]: (data) => {
                isShowingAds = false;
                const isSerie = this.isSerie()
                const haceResume = this.resumeEndAds > 0;
                const adNowPlaying = this.reviewAdsNowPlaying(adBreakId, beforeAdBreakId);
                const { isPostRoll, isPreRoll } = adNowPlaying;

                const isMovieWithPostRoll = !isSerie && isPostRoll

                isPreRoll && haceResume && BitmovinPlayer.seek(this.resumeEndAds);
                closeSkipButtonAds();
                clearTimeout(this.setTimeOutSkepButton);

                if (!BitmovinPlayer.isPlaying()) {

                  isPreRoll && BitmovinPlayer.play();

                  if(isMovieWithPostRoll){
                    this.dispatchStopping();
                  }
                }

                isPostRoll && this.playbackNextEpisode(adBreakId);
                isPreRoll && this.eventsToPlayerReady();
                adBreakId = "";
                this.includeAds = false;
            },

            [PlayerEvent.AdError]: async (data) => {
                isShowingAds = false;
                const adNowPlaying = this.reviewAdsNowPlaying(adBreakId, beforeAdBreakId);
                const { isPreRoll } = adNowPlaying;
                console.error('❌ [BITMOVIN - LOG]: Error while loading Ads:', data);
                closeSkipButtonAds();
                clearTimeout(this.setTimeOutSkepButton);
                isPreRoll && this.eventsToPlayerReady();
                this.includeAds = false;
            },
        };

        return events;
    }

    _onDRMError(e) {}

    removeEventsListener() {
        /**
         * Please remove events as you add events
         */
        BitmovinPlayer.off(PlayerEvent.SourceLoaded);
        BitmovinPlayer.off(PlayerEvent.Play);
        BitmovinPlayer.off(PlayerEvent.Paused);
        BitmovinPlayer.off(PlayerEvent.StallStarted);
        BitmovinPlayer.off(PlayerEvent.StallEnded);
        BitmovinPlayer.off(PlayerEvent.Seek);
        BitmovinPlayer.off(PlayerEvent.Seeked);
        BitmovinPlayer.off(PlayerEvent.Error);
        BitmovinPlayer.off(PlayerEvent.Ready);
        BitmovinPlayer.off(PlayerEvent.PlaybackFinished);
        BitmovinPlayer.off(PlayerEvent.TimeChanged);
        BitmovinPlayer.off(PlayerEvent.AdStarted);
        BitmovinPlayer.off(PlayerEvent.AdSkipped);
        BitmovinPlayer.off(PlayerEvent.AdFinished);
        BitmovinPlayer.off(PlayerEvent.AdBreakFinished);
        BitmovinPlayer.off(PlayerEvent.AdError);
    }

    getCurrentTime() {
        return this.currentTime;
    }

    getDuration() {
        return this._duration;
    }

    setDuration(duration) {
        this._duration = duration;
    }

    getBitmovinState() {}
    /* Events */

    _onLoad() {
        console.log('[BITMOVIN] _onLoad');
        if (this.options.events.onLoad) {
            this.options.events.onLoad();
        }
        this._fireNowEvent();
    }

    _onUnknownEvent(eventType, param1, param2) {}

    _onBufferingStart() {
        console.log('[BITMOVIN] _onBufferingStart');
        this.onPlayerStateBuffer();
        if (this.options.events.onBufferingStart) {
            this.options.events.onBufferingStart();
        }
    }

    _onBufferingComplete() {
        console.log('[BITMOVIN] _onBufferingComplete');

        // If stop and ends buffering, nothing to do
        if (this.getCurrentPlayerState() === PONSTOP) {
            return;
        }

        if (!this.firstBufferingComplete) {
            console.log('[SEEKST] _onBufferingComplete ya se lleno el buffer');
            this.firstBufferingComplete = true;
        }

        // If current state is on connecting, then we go to play
        if (this.getCurrentPlayerState() === PONCONNECT) {
            this.onPlayerStatePlay();
        } else {
            // Set same state as last
            this.setCurrentPlayerState(this.previousPlayerState);
        }

        if (this.options.events.onBufferingFinish) {
            this.options.events.onBufferingFinish();
        }
    }

    _onBufferingProgress(percent) {
        console.log('[BITMOVIN] _onBufferingProgress');
        if (this.options.events.onBufferingProgress) {
            this.options.events.onBufferingProgress(percent);
        }
    }

    _onWaiting() {
        console.log('[BITMOVIN] _onWaiting');
        if (this.options.events.onWaiting) {
            this.options.events.onWaiting();
        }
    }

    _onTimeUpdate(currentTime) {
        this.currentTime = currentTime;
        if (this.options.events.onTimeUpdate) {
            this.options.events.onTimeUpdate(currentTime, currentTime * 1000);
        }
    }

    _onPlaying() {
        console.log('[BITMOVIN] _onPlaying');
        if (this.options.events.onPlaying) {
            this.options.events.onPlaying();
        }
    }

    _onError(error) {
        const { code, message, name, type } = error;
        console.log('[BITMOVIN] _onError');
        console.log(error);
        this.hasAudioTracks = false;
        this._isOnLoaded = false;
        this.contentIsReady = false;
        this.firstBufferingComplete = false;
        this.seek_resume = 0;
        this.stop();
        if (this.options.events.onError) {
            this.options.events.onError(code, `${name} ${message} | ${type}`);
        }
    }

    _onFinished() {
        console.log('[BITMOVIN] _onFinished');
        this.destroy();
        // We dont need to send the stop state to the player here, it was sending in stop method that executes before this onfinish
        if (this.options.events.onFinished) {
            this.options.events.onFinished();
        }
    }

    _onCanPlay() {
        // We already could play...so show the player...
        console.log('[BITMOVIN] _onCanPlay> ');
        if (this.options.events.onCanPlay) {
            this.options.events.onCanPlay();
        }
    }

    _onDurationChange() {
        console.log('[BITMOVIN] _onDurationChange> ');
        if (this.options.events.onDurationChange) {
            this.options.events.onDurationChange();
        }
    }

    /* END Events */

    /* MULTIPLE AUDIOTRACKS */

    async tryGetAudioTracks(currentTry) {
        if (!this._isOnLoaded) {
            // this.consolelog('=> PAU tryGetAudioTracks currentTry: ' + currentTry);
            console.log(
                `+++ [BITMOVIN]> tryGetAudioTracks retry number: [${currentTry}] - Tizen AVPlayer audioTracks...`
            );
            if (currentTry >= this.retryLimitAudioTrack) {
                throw new Error('Fail to get audioTracks');
                console.log('[BITMOVIN]> Error, player instance could not initialize');
                return;
            }
            await Utils.sleep(this.retryIntervalAudioTrack);

            return this.tryGetAudioTracks(++currentTry);
        }
        console.log(
            `+++ [BITMOVIN]> tryToGetAudioTracks retry number: [${currentTry}] -  Tizen AVPlayer audiioTracks is READY`
        );

        // this.consolelog('=> PAU tryGetAudioTracks rompe interval');
        return this.getAudioTracks();
    }

    getAudioTracks() {
        console.log('[BITMOVIN] getAudioTracks> ');
        if (!this._isOnLoaded) {
            console.log('=> PAU getAudioTracks, dont get source loaded yet ');
            return this.tryGetAudioTracks(1);
        }

        if (this.hasAudioTracks) {
            return new Promise((resolve) => {
                resolve(this.audioTracks);
            });
        }

        return new Promise((resolve) => {
            console.info('[BITMOVIN] Recuperado info de tracks...');
            const audioTracks = BitmovinPlayer.getAvailableAudio();
            let i = 0;
            if (Array.isArray(audioTracks)) {
                for (i = 0; i < audioTracks.length; i++) {
                    const oneTrack = audioTracks[i];
                    this.audioTracks.push({ id: oneTrack.id, lang: oneTrack.label });
                }
            }

            console.info('[BITMOVIN] Audio Tracks: ', this.audioTracks);
            this.hasAudioTracks = true;
            // this.consolelog('=> PAU ya tiene tracks de audio, son ' + this.audioTracks.length);
            resolve(this.audioTracks);
        });
    }

    /**
     *
     * @param {*} currentTry
     * @param {*} lang
     * Need to await for the player to can change the audio track
     */
    async trySetAudioTrack(currentTry, lang) {
        if (!this._isOnLoaded) {
            if (currentTry >= this.retryLimitAudioTrack) {
                throw new Error('Fail to set audioTrack');
                return;
            }
            // this.consolelog('=> PAU trySetAudioTrack Espera interval para setaudiotrack');
            await Utils.sleep(this.retryIntervalAudioTrack);

            return this.trySetAudioTrack(++currentTry, lang);
        }
        return this.setAudioTrack(lang);
    }

    // @codeTrack iso id i.e.: esp, eng, por, ori
    setAudioTrack(codeTrack) {
        // If player is not playing yet, we need to await...when the current playing-time will be > 0
        if (!this._isOnLoaded) {
            console.info('+++ [BITMOVIN] setAudioTrack Delay 1s to SET the audio track info again');
            return this.trySetAudioTrack(1, codeTrack);
        }

        console.log('+++ => PAU setAudioTrack audiotrack setting to ', codeTrack);

        // Este es en check adicional por si no pudimos
        // recuperar los tracks al inicio
        if (!Array.isArray(this.audioTracks)) {
            this.audioTracks = [];
        }
        if (this.audioTracks.length < 1) {
            const audioTracks = BitmovinPlayer.getAvailableAudio();
            console.info(
                '+++ [BITMOVIN] setAudioTrack RECHECK for tracks, BitmovinPlayer.getAvailableAudio(), we find next audioTracks: ',
                audioTracks
            );
            let x = 0;
            if (Array.isArray(audioTracks)) {
                for (x = 0; x < audioTracks.length; x++) {
                    const oneTrack = audioTracks[x];
                    this.audioTracks.push({ id: oneTrack.id, lang: oneTrack.label });
                }
            }
        }

        return new Promise((resolve, reject) => {
            if (!this._isOnLoaded) {
                reject('+++ setAudioTrack Dont have audioTracks information');
            }

            let currentAudio = BitmovinPlayer.getAudio();
            console.log('+++ setAudioTrack => PAU currentAudio ', currentAudio);

            let internalAudioId = this.getAudioIndexOfCode(codeTrack);
            console.log(
                '+++ setAudioTrack => PAU setAudioTrack, internalAudioId es: ',
                internalAudioId
            );
            if (internalAudioId === null) {
                reject(
                    '+++ setAudioTrack Dont have audioTracks information, index lang does not exist'
                );
            } else {
                if (internalAudioId === currentAudio.id) {
                    console.info(
                        '+++ setAudioTrack => PAU [BITMOVIN] Same audioTrack, nothing to do'
                    );
                    resolve(true);
                }

                BitmovinPlayer.setAudio(internalAudioId);
                console.log(
                    '+++ setAudioTrack => PAU setAudioTrack, cambiando a internalAudioId.id: ',
                    internalAudioId
                );
                console.log('+++ setAudioTrack => PAU setAudioTrack, cambiando a: ', codeTrack);
                // this.consolelog('=> PAU setAudioTrack, cambiando a: ' + codeTrack);
                resolve(true);
            }
        });
    }

    getAudioIndexOfCode(codeTrack) {
        console.log('=> PAU getAudioIndexOfCode codeTrack es: ', codeTrack);
        console.log('=> PAU getAudioIndexOfCode this.audioTracks es: ', this.audioTracks);
        let ret = null;
        for (let j = 0; j < this.audioTracks.length; j++) {
            if (this.audioTracks[j].lang === codeTrack) {
                ret = this.audioTracks[j].id;
                break;
            }
        }
        console.log('=> PAU getAudioIndexOfCode ret es: ', ret);
        return ret;
    }

    setAudioTrackLive(codeTrack, subtitleTrack) {
        this.setAudioTrack(codeTrack)
    }

    /* END MULTIPLE AUDIOTRACKS */

    setCancelPostRoll(value) {
        this.cancelPostRoll = value;
    }
}

export default AAFBitmovinPlayer;



// WEBPACK FOOTER //
// ./src/devices/all/bitmovin/AAFBitmovinPlayer.js